import { ChatIcon } from "@heroicons/react/outline";

const CommitMessage = ({ message }: { message: string }) => (
  <div className="ml-6 flex items-center justify-between">
    <div className="py-0.5 text-xs text-gray-600">
      <ChatIcon className="mr-1 inline h-4 w-auto pb-0.5" aria-hidden="true" />
      {message}
    </div>
  </div>
);

export default CommitMessage;
